import { Box, BoxProps, ColorOptions, Image, Spacer, Text, TextProps } from '@jfs/ui-new'
import { useStores } from '../data/store'
import { convertHexToRGBA } from '../utils'
import { TEMPLATE } from '../utils/constants'
import { staticStrings } from '../utils/string'
import TOneFooter from './TOneFooter'

const Footer = (props: any) => {
  const { merchantTheme, template } = useStores((root) => ({
    merchantTheme: root?.config?.merchantTheme,
    template: root?.merchant?.template,
  }))
  const { isBottomAligned, isHomePage = false } = props
  const displayFooter = () => {
    switch (template.id) {
      case TEMPLATE.MILK_BASKET:
        console.log('rendering TOneFooter')
        return (
          <>
            <TOneFooter />
            {isHomePage && <Spacer size={24} />}
          </>
        )
      default:
        console.log('rendering default footer')
        return <DefaultFooter theme={merchantTheme} isBottomAligned={isBottomAligned} />
    }
  }

  return <>{displayFooter()}</>
}

const DefaultFooter = ({ theme, isBottomAligned }: { theme: any; isBottomAligned: boolean }) => {
  console.log('DefaultFooter called', theme)
  const style = styles(theme)
  return (
    <Box
      testID="footerTest"
      {...(isBottomAligned ? { ...style.containerViewBottomWrapped } : { ...style.containerView })}>
      <Box {...style.poweredBy}>
        <Text {...style.poweredByInner}>{staticStrings.poweredBy}</Text>
        <Spacer size={4} direction={'horizontal'} />
        <Image height={22} width={22} resizeMode="contain" source={require('../assets/images/jiopay_logo.png')} />
        <Spacer size={4} direction={'horizontal'} />
        <Text {...style.jiomoneyText}>{staticStrings.jioPay}</Text>
      </Box>
      <Box {...style.imageContainer}>
        <Image
          {...style.imageView}
          resizeMode="contain"
          source={require('../assets/images/verified_by_visa_logo_small.png')}
        />
        <Spacer size={18} direction="horizontal" />
        <Image {...style.imageView} resizeMode="contain" source={require('../assets/images/securecode.png')} />
        <Spacer size={18} direction="horizontal" />
        <Image {...style.imageView} resizeMode="contain" source={require('../assets/images/pci-dss-compliant.png')} />
        <Spacer size={18} direction="horizontal" />
        <Image {...style.imageView} resizeMode="contain" source={require('../assets/images/safekey-logo.png')} />
      </Box>
    </Box>
  )
}

const commonContainerStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  flexDirection: 'row',
  width: '100%',
  position: 'relative',
  paddingVertical: 8,
} as BoxProps

const styles = (merchantTheme: any) => {
  const direction = { flexDirection: 'column-reverse' } as BoxProps
  console.log('Footer styles', merchantTheme)
  return {
    containerView: {
      ...commonContainerStyle,
      ...direction,
      paddingVertical: 16,
      backgroundColor: convertHexToRGBA(merchantTheme?.brandColor, 10) as ColorOptions, //('#e7f3f7' as ColorOptions),
      height: 92,
    } as BoxProps,
    containerViewBottomWrapped: {
      ...commonContainerStyle,
      ...direction,
      backgroundColor: convertHexToRGBA(merchantTheme?.brandColor, 10) as ColorOptions, //('#e7f3f7' as ColorOptions),
      paddingVertical: 16,
      position: 'absolute',
      bottom: 0,
    } as BoxProps,
    imageContainer: {
      flex: 1,
      flexDirection: 'row',
      marginVertical: 10,
      alignItems: 'center',
      justifyContent: 'flex-end',
      paddingHorizontal: 'SMALL',
      minHeight: 12,
    } as BoxProps,
    imageView: {
      paddingRight: 60,
      height: 16,
      width: 44,
    },
    poweredBy: {
      flex: 1,
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'flex-start',
      paddingHorizontal: 'SMALL',
      paddingVertical: 8,
      minHeight: 12,
    } as BoxProps,
    poweredByInner: {
      color: merchantTheme?.bodyTextColor as ColorOptions,
      fontSize: 12,
      fontFamily: 'jioType-Medium',
    } as TextProps,
    jiomoneyText: {
      color: merchantTheme?.bodyTextColor as ColorOptions,
      fontSize: 12,
      fontWeight: '500',
      fontFamily: 'jioType-Medium',
    } as TextProps,
    alignHorizontal: {
      flexDirection: 'row',
    } as BoxProps,
    alignVertical: {
      flexDirection: 'column',
      border: 'solid 1px',
    } as BoxProps,
  }
}

export default Footer
